import { CreateProducerState } from '../types/createProducerSliceTypes';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';

const initialCreateProducerSteps = {
  selectProducerType: {
    producerType: '',
  },
  producerDetails: {
    firstName: '',
    lastName: '',
    middleName: '',
    prefix: '',
    suffix: '',
    producerNumber: '',
    genderId: null,
    documentDeliveryPreferenceId: null,
    producerGroupId: null,
  },
  producerGroupDetails: {
    name: '',
    producerNumber: '',
    tin: '',
    representativeFirstName: '',
    representativeLastName: '',
    department: '',
    documentDeliveryPreferenceId: null,
  },
};

export const createProducerInitialState: CreateProducerState = {
  createProducerType: EdsEntityCodes.Producer,
  createProducerSteps: initialCreateProducerSteps,
  statuses: {
    isCreateProducerLoading: false,
  },
};
